import React from "react";

export const AdFormContext = React.createContext();